import React, { useEffect } from "react";

const LeaveZoom = () => {
  useEffect(() => {
    window.close();
  }, []);

  return <div>Thank You For Attending</div>;
};

export default LeaveZoom;
